import { ShieldCheck, Truck, MessageCircle, Tag } from "lucide-react";
import { CRAFT_IMAGE } from "../data/watches";
import { Reveal } from "./Reveal";

const VALUE_PROPS = [
  {
    icon: Tag,
    title: "Precios honestos",
    body: "Compramos directo a fábrica y te llegan sin intermediarios ni sobreprecio. Calidad de gama alta a precio justo.",
  },
  {
    icon: ShieldCheck,
    title: "Relojes originales",
    body: "Vendemos piezas 100% originales de Pagani Design, Wishdoit y Specht & Söhne, con garantía y empaque de fábrica.",
  },
  {
    icon: MessageCircle,
    title: "Atención por WhatsApp",
    body: "Hablas directo con nosotros. Sin formularios, sin esperas, sin bots.",
  },
  {
    icon: Truck,
    title: "Envíos a todo el mundo",
    body: "Entrega en 5-12 días. Embalaje protegido y con seguimiento.",
  },
];

export const Craftsmanship = () => {
  return (
    <section
      id="artesania"
      data-testid="craft-section"
      className="relative py-24 sm:py-36 px-6 sm:px-12 bg-[var(--brand-surface)]"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 items-center">
        <Reveal className="md:col-span-6">
          <div className="relative aspect-[4/5] md:aspect-[5/6] w-full overflow-hidden">
            <img
              src={CRAFT_IMAGE}
              alt="Detalle de reloj Romero Watches"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-[#050B14]/40 via-transparent to-transparent" />
          </div>
        </Reveal>

        <div className="md:col-span-6 flex flex-col">
          <Reveal delay={120}>
            <div className="font-accent-rw text-[11px] uppercase tracking-[0.4em] text-[var(--brand-gold)] mb-6 flex items-center gap-3">
              <span className="w-8 h-px bg-[var(--brand-gold)]" />
              Movimiento Miyota
            </div>
            <h2 className="font-serif-rw text-4xl sm:text-5xl font-light leading-[1.05] tracking-tight text-slate-50">
              Corazón mecánico
              <br />
              <em className="italic text-[var(--brand-gold)] font-light">
                japonés, confianza eterna.
              </em>
            </h2>
            <p className="mt-8 text-base text-slate-400 leading-relaxed font-light max-w-lg">
              Movimientos automáticos Miyota fabricados en Japón. Sin pilas, sin
              mantenimiento complicado: el reloj se da cuerda solo con el
              movimiento de tu muñeca. Precisión probada en millones de relojes
              de gama alta en todo el mundo.
            </p>
          </Reveal>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/5">
            {VALUE_PROPS.map((v, i) => {
              const Icon = v.icon;
              return (
                <Reveal
                  key={v.title}
                  delay={200 + i * 80}
                  className="bg-[var(--brand-surface)] p-7"
                >
                  <Icon
                    size={22}
                    strokeWidth={1.4}
                    className="text-[var(--brand-gold)] mb-5"
                  />
                  <h3 className="font-serif-rw text-2xl text-slate-50 font-light leading-tight">
                    {v.title}
                  </h3>
                  <p className="mt-3 text-sm text-slate-400 leading-relaxed font-light">
                    {v.body}
                  </p>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Craftsmanship;
